// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/work_location.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/work_location.proto.
 */
export const file_general_work_location: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum protos.general.WorkLocation
 */
export enum WorkLocation {
  /**
   * @generated from enum value: WORK_LOCATION_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: WORK_LOCATION_CA_QC_MONTREAL = 1;
   */
  CA_QC_MONTREAL = 1,

  /**
   * @generated from enum value: WORK_LOCATION_CA_ON_TORONTO = 2;
   */
  CA_ON_TORONTO = 2,

  /**
   * @generated from enum value: WORK_LOCATION_CA_BC_VANCOUVER = 3;
   */
  CA_BC_VANCOUVER = 3,

  /**
   * @generated from enum value: WORK_LOCATION_CA_QC_QUEBEC = 4;
   */
  CA_QC_QUEBEC = 4,

  /**
   * @generated from enum value: WORK_LOCATION_CA_ON_OTTAWA = 5;
   */
  CA_ON_OTTAWA = 5,

  /**
   * @generated from enum value: WORK_LOCATION_AR_C_BUENOS_AIRES = 6;
   */
  AR_C_BUENOS_AIRES = 6,

  /**
   * @generated from enum value: WORK_LOCATION_AR_B_LA_PLATA = 7;
   */
  AR_B_LA_PLATA = 7,

  /**
   * @generated from enum value: WORK_LOCATION_AR_B_MAR_DEL_PLATA = 8;
   */
  AR_B_MAR_DEL_PLATA = 8,

  /**
   * @generated from enum value: WORK_LOCATION_AR_X_CORDOBA = 9;
   */
  AR_X_CORDOBA = 9,

  /**
   * @generated from enum value: WORK_LOCATION_AR_S_ROSARIO = 10;
   */
  AR_S_ROSARIO = 10,

  /**
   * @generated from enum value: WORK_LOCATION_AR_S_SANTA_FE = 11;
   */
  AR_S_SANTA_FE = 11,

  /**
   * @generated from enum value: WORK_LOCATION_AR_M_MENDOZA = 12;
   */
  AR_M_MENDOZA = 12,

  /**
   * @generated from enum value: WORK_LOCATION_AU_NSW_SYDNEY = 13;
   */
  AU_NSW_SYDNEY = 13,

  /**
   * @generated from enum value: WORK_LOCATION_AU_VIC_MELBOURNE = 14;
   */
  AU_VIC_MELBOURNE = 14,

  /**
   * @generated from enum value: WORK_LOCATION_AU_QLD_BRISBANE = 15;
   */
  AU_QLD_BRISBANE = 15,

  /**
   * @generated from enum value: WORK_LOCATION_AU_SA_ADELAIDE = 16;
   */
  AU_SA_ADELAIDE = 16,

  /**
   * @generated from enum value: WORK_LOCATION_AU_WA_PERTH = 17;
   */
  AU_WA_PERTH = 17,

  /**
   * @generated from enum value: WORK_LOCATION_AT_9_VIENNA = 18;
   */
  AT_9_VIENNA = 18,

  /**
   * @generated from enum value: WORK_LOCATION_AT_5_SALZBURG = 19;
   */
  AT_5_SALZBURG = 19,

  /**
   * @generated from enum value: WORK_LOCATION_BE_BRU_BRUSSELS = 20;
   */
  BE_BRU_BRUSSELS = 20,

  /**
   * @generated from enum value: WORK_LOCATION_BE_VLG_ANTWERP = 21;
   */
  BE_VLG_ANTWERP = 21,

  /**
   * @generated from enum value: WORK_LOCATION_BE_VOV_GHENT = 22;
   */
  BE_VOV_GHENT = 22,

  /**
   * @generated from enum value: WORK_LOCATION_BR_SP_SAO_PAULO = 23;
   */
  BR_SP_SAO_PAULO = 23,

  /**
   * @generated from enum value: WORK_LOCATION_BR_RJ_RIO_DE_JANEIRO = 24;
   */
  BR_RJ_RIO_DE_JANEIRO = 24,

  /**
   * @generated from enum value: WORK_LOCATION_BR_MG_BELO_HORIZONTE = 25;
   */
  BR_MG_BELO_HORIZONTE = 25,

  /**
   * @generated from enum value: WORK_LOCATION_BR_RS_PORTO_ALEGRE = 26;
   */
  BR_RS_PORTO_ALEGRE = 26,

  /**
   * @generated from enum value: WORK_LOCATION_BR_BA_SALVADOR = 27;
   */
  BR_BA_SALVADOR = 27,

  /**
   * @generated from enum value: WORK_LOCATION_BR_PE_RECIFE = 28;
   */
  BR_PE_RECIFE = 28,

  /**
   * @generated from enum value: WORK_LOCATION_BR_DF_BRASILIA = 29;
   */
  BR_DF_BRASILIA = 29,

  /**
   * @generated from enum value: WORK_LOCATION_BR_PR_CURITIBA = 30;
   */
  BR_PR_CURITIBA = 30,

  /**
   * @generated from enum value: WORK_LOCATION_BR_AM_MANAUS = 31;
   */
  BR_AM_MANAUS = 31,

  /**
   * @generated from enum value: WORK_LOCATION_BG_22_SOFIA = 32;
   */
  BG_22_SOFIA = 32,

  /**
   * @generated from enum value: WORK_LOCATION_BG_16_PLOVDIV = 33;
   */
  BG_16_PLOVDIV = 33,

  /**
   * @generated from enum value: WORK_LOCATION_CA_BC_VICTORIA = 34;
   */
  CA_BC_VICTORIA = 34,

  /**
   * @generated from enum value: WORK_LOCATION_CA_BC_KELOWNA = 35;
   */
  CA_BC_KELOWNA = 35,

  /**
   * @generated from enum value: WORK_LOCATION_CA_BC_WHISTLER = 36;
   */
  CA_BC_WHISTLER = 36,

  /**
   * @generated from enum value: WORK_LOCATION_CA_BC_KAMLOOPS = 37;
   */
  CA_BC_KAMLOOPS = 37,

  /**
   * @generated from enum value: WORK_LOCATION_CA_ON_HAMILTON = 38;
   */
  CA_ON_HAMILTON = 38,

  /**
   * @generated from enum value: WORK_LOCATION_CA_ON_SUDBURY = 39;
   */
  CA_ON_SUDBURY = 39,

  /**
   * @generated from enum value: WORK_LOCATION_CA_ON_THUNDER_BAY = 40;
   */
  CA_ON_THUNDER_BAY = 40,

  /**
   * @generated from enum value: WORK_LOCATION_CA_ON_KINGSTON = 41;
   */
  CA_ON_KINGSTON = 41,

  /**
   * @generated from enum value: WORK_LOCATION_CA_ON_LONDON = 42;
   */
  CA_ON_LONDON = 42,

  /**
   * @generated from enum value: WORK_LOCATION_CA_ON_WINDSOR = 43;
   */
  CA_ON_WINDSOR = 43,

  /**
   * @generated from enum value: WORK_LOCATION_CA_QC_GATINEAU = 44;
   */
  CA_QC_GATINEAU = 44,

  /**
   * @generated from enum value: WORK_LOCATION_CA_QC_SHERBROOKE = 45;
   */
  CA_QC_SHERBROOKE = 45,

  /**
   * @generated from enum value: WORK_LOCATION_CA_QC_TROIS_RIVIERES = 46;
   */
  CA_QC_TROIS_RIVIERES = 46,

  /**
   * @generated from enum value: WORK_LOCATION_CA_AB_CALGARY = 47;
   */
  CA_AB_CALGARY = 47,

  /**
   * @generated from enum value: WORK_LOCATION_CA_AB_EDMONTON = 48;
   */
  CA_AB_EDMONTON = 48,

  /**
   * @generated from enum value: WORK_LOCATION_CA_MB_WINNIPEG = 49;
   */
  CA_MB_WINNIPEG = 49,

  /**
   * @generated from enum value: WORK_LOCATION_CA_SK_REGINA = 50;
   */
  CA_SK_REGINA = 50,

  /**
   * @generated from enum value: WORK_LOCATION_CA_SK_SASKATOON = 51;
   */
  CA_SK_SASKATOON = 51,

  /**
   * @generated from enum value: WORK_LOCATION_CA_NS_HALIFAX = 52;
   */
  CA_NS_HALIFAX = 52,

  /**
   * @generated from enum value: WORK_LOCATION_CA_NB_FREDERICTON = 53;
   */
  CA_NB_FREDERICTON = 53,

  /**
   * @generated from enum value: WORK_LOCATION_CA_NB_SAINT_JOHN = 54;
   */
  CA_NB_SAINT_JOHN = 54,

  /**
   * @generated from enum value: WORK_LOCATION_CA_NB_MONCTON = 55;
   */
  CA_NB_MONCTON = 55,

  /**
   * @generated from enum value: WORK_LOCATION_CA_PE_CHARLOTTETOWN = 56;
   */
  CA_PE_CHARLOTTETOWN = 56,

  /**
   * @generated from enum value: WORK_LOCATION_CA_NL_ST_JOHNS = 57;
   */
  CA_NL_ST_JOHNS = 57,

  /**
   * @generated from enum value: WORK_LOCATION_CA_YT_WHITEHORSE = 58;
   */
  CA_YT_WHITEHORSE = 58,

  /**
   * @generated from enum value: WORK_LOCATION_CA_NT_YELLOWKNIFE = 59;
   */
  CA_NT_YELLOWKNIFE = 59,

  /**
   * @generated from enum value: WORK_LOCATION_CA_NU_IQALUIT = 60;
   */
  CA_NU_IQALUIT = 60,

  /**
   * @generated from enum value: WORK_LOCATION_CZ_20_PRAGUE = 61;
   */
  CZ_20_PRAGUE = 61,

  /**
   * @generated from enum value: WORK_LOCATION_DK_84_COPENHAGEN = 62;
   */
  DK_84_COPENHAGEN = 62,

  /**
   * @generated from enum value: WORK_LOCATION_EE_37_TALLINN = 63;
   */
  EE_37_TALLINN = 63,

  /**
   * @generated from enum value: WORK_LOCATION_FI_18_HELSINKI = 64;
   */
  FI_18_HELSINKI = 64,

  /**
   * @generated from enum value: WORK_LOCATION_FI_11_TAMPERE = 65;
   */
  FI_11_TAMPERE = 65,

  /**
   * @generated from enum value: WORK_LOCATION_FR_IDF_PARIS = 66;
   */
  FR_IDF_PARIS = 66,

  /**
   * @generated from enum value: WORK_LOCATION_FR_PAC_NICE = 67;
   */
  FR_PAC_NICE = 67,

  /**
   * @generated from enum value: WORK_LOCATION_FR_PAC_MARSEILLE = 68;
   */
  FR_PAC_MARSEILLE = 68,

  /**
   * @generated from enum value: WORK_LOCATION_FR_PAC_CANNES = 69;
   */
  FR_PAC_CANNES = 69,

  /**
   * @generated from enum value: WORK_LOCATION_FR_ARA_LYON = 70;
   */
  FR_ARA_LYON = 70,

  /**
   * @generated from enum value: WORK_LOCATION_FR_ARA_ANNECY = 71;
   */
  FR_ARA_ANNECY = 71,

  /**
   * @generated from enum value: WORK_LOCATION_FR_OCC_TOULOUSE = 72;
   */
  FR_OCC_TOULOUSE = 72,

  /**
   * @generated from enum value: WORK_LOCATION_FR_OCC_MONTPELLIER = 73;
   */
  FR_OCC_MONTPELLIER = 73,

  /**
   * @generated from enum value: WORK_LOCATION_FR_GES_STRASBOURG = 74;
   */
  FR_GES_STRASBOURG = 74,

  /**
   * @generated from enum value: WORK_LOCATION_FR_PDL_NANTES = 75;
   */
  FR_PDL_NANTES = 75,

  /**
   * @generated from enum value: WORK_LOCATION_FR_PDL_ANGERS = 76;
   */
  FR_PDL_ANGERS = 76,

  /**
   * @generated from enum value: WORK_LOCATION_FR_NAQ_BORDEAUX = 77;
   */
  FR_NAQ_BORDEAUX = 77,

  /**
   * @generated from enum value: WORK_LOCATION_FR_NAQ_LA_ROCHELLE = 78;
   */
  FR_NAQ_LA_ROCHELLE = 78,

  /**
   * @generated from enum value: WORK_LOCATION_FR_NAQ_BIARRITZ = 79;
   */
  FR_NAQ_BIARRITZ = 79,

  /**
   * @generated from enum value: WORK_LOCATION_FR_HDF_LILLE = 80;
   */
  FR_HDF_LILLE = 80,

  /**
   * @generated from enum value: WORK_LOCATION_FR_HDF_AMIENS = 81;
   */
  FR_HDF_AMIENS = 81,

  /**
   * @generated from enum value: WORK_LOCATION_FR_BRE_RENNES = 82;
   */
  FR_BRE_RENNES = 82,

  /**
   * @generated from enum value: WORK_LOCATION_FR_BRE_BREST = 83;
   */
  FR_BRE_BREST = 83,

  /**
   * @generated from enum value: WORK_LOCATION_FR_NOR_ROUEN = 84;
   */
  FR_NOR_ROUEN = 84,

  /**
   * @generated from enum value: WORK_LOCATION_FR_NOR_CAEN = 85;
   */
  FR_NOR_CAEN = 85,

  /**
   * @generated from enum value: WORK_LOCATION_FR_NOR_LE_HAVRE = 86;
   */
  FR_NOR_LE_HAVRE = 86,

  /**
   * @generated from enum value: WORK_LOCATION_FR_BFC_DIJON = 87;
   */
  FR_BFC_DIJON = 87,

  /**
   * @generated from enum value: WORK_LOCATION_FR_CVL_TOURS = 88;
   */
  FR_CVL_TOURS = 88,

  /**
   * @generated from enum value: WORK_LOCATION_FR_CVL_ORLEANS = 89;
   */
  FR_CVL_ORLEANS = 89,

  /**
   * @generated from enum value: WORK_LOCATION_FR_COR_AJACCIO = 90;
   */
  FR_COR_AJACCIO = 90,

  /**
   * @generated from enum value: WORK_LOCATION_FR_COR_BASTIA = 91;
   */
  FR_COR_BASTIA = 91,

  /**
   * @generated from enum value: WORK_LOCATION_FR_MQ_MARTINIQUE = 92;
   */
  FR_MQ_MARTINIQUE = 92,

  /**
   * @generated from enum value: WORK_LOCATION_FR_GP_GUADELOUPE = 93;
   */
  FR_GP_GUADELOUPE = 93,

  /**
   * @generated from enum value: WORK_LOCATION_FR_GF_GUYANE = 94;
   */
  FR_GF_GUYANE = 94,

  /**
   * @generated from enum value: WORK_LOCATION_FR_RE_LA_REUNION = 95;
   */
  FR_RE_LA_REUNION = 95,

  /**
   * @generated from enum value: WORK_LOCATION_GE_TB_TBILISI = 96;
   */
  GE_TB_TBILISI = 96,

  /**
   * @generated from enum value: WORK_LOCATION_GE_AJ_BATUMI = 97;
   */
  GE_AJ_BATUMI = 97,

  /**
   * @generated from enum value: WORK_LOCATION_DE_BE_BERLIN = 98;
   */
  DE_BE_BERLIN = 98,

  /**
   * @generated from enum value: WORK_LOCATION_DE_BB_POTSDAM = 99;
   */
  DE_BB_POTSDAM = 99,

  /**
   * @generated from enum value: WORK_LOCATION_DE_BY_MUNICH = 100;
   */
  DE_BY_MUNICH = 100,

  /**
   * @generated from enum value: WORK_LOCATION_DE_NW_COLOGNE = 101;
   */
  DE_NW_COLOGNE = 101,

  /**
   * @generated from enum value: WORK_LOCATION_DE_HH_HAMBURG = 102;
   */
  DE_HH_HAMBURG = 102,

  /**
   * @generated from enum value: WORK_LOCATION_DE_NW_DUSSELDORF = 103;
   */
  DE_NW_DUSSELDORF = 103,

  /**
   * @generated from enum value: WORK_LOCATION_DE_BW_STUTTGART = 104;
   */
  DE_BW_STUTTGART = 104,

  /**
   * @generated from enum value: WORK_LOCATION_DE_HE_FRANKFURT = 105;
   */
  DE_HE_FRANKFURT = 105,

  /**
   * @generated from enum value: WORK_LOCATION_DE_SN_LEIPZIG = 106;
   */
  DE_SN_LEIPZIG = 106,

  /**
   * @generated from enum value: WORK_LOCATION_DE_BW_LUDWIGSBURG = 107;
   */
  DE_BW_LUDWIGSBURG = 107,

  /**
   * @generated from enum value: WORK_LOCATION_DE_HB_BREMEN = 108;
   */
  DE_HB_BREMEN = 108,

  /**
   * @generated from enum value: WORK_LOCATION_DE_SN_DRESDEN = 109;
   */
  DE_SN_DRESDEN = 109,

  /**
   * @generated from enum value: WORK_LOCATION_DE_NI_HANOVER = 110;
   */
  DE_NI_HANOVER = 110,

  /**
   * @generated from enum value: WORK_LOCATION_GR_I_ATHENS = 111;
   */
  GR_I_ATHENS = 111,

  /**
   * @generated from enum value: WORK_LOCATION_GR_B_THESSALONIKI = 112;
   */
  GR_B_THESSALONIKI = 112,

  /**
   * @generated from enum value: WORK_LOCATION_HU_BU_BUDAPEST = 113;
   */
  HU_BU_BUDAPEST = 113,

  /**
   * @generated from enum value: WORK_LOCATION_ID_JK_JAKARTA = 114;
   */
  ID_JK_JAKARTA = 114,

  /**
   * @generated from enum value: WORK_LOCATION_ID_BA_DENPASAR = 115;
   */
  ID_BA_DENPASAR = 115,

  /**
   * @generated from enum value: WORK_LOCATION_IE_D_DUBLIN = 116;
   */
  IE_D_DUBLIN = 116,

  /**
   * @generated from enum value: WORK_LOCATION_IE_CO_CORK = 117;
   */
  IE_CO_CORK = 117,

  /**
   * @generated from enum value: WORK_LOCATION_IE_LK_LIMERICK = 118;
   */
  IE_LK_LIMERICK = 118,

  /**
   * @generated from enum value: WORK_LOCATION_IT_62_ROME = 119;
   */
  IT_62_ROME = 119,

  /**
   * @generated from enum value: WORK_LOCATION_IT_25_MILAN = 120;
   */
  IT_25_MILAN = 120,

  /**
   * @generated from enum value: WORK_LOCATION_IT_21_TURIN = 121;
   */
  IT_21_TURIN = 121,

  /**
   * @generated from enum value: WORK_LOCATION_IT_72_NAPLES = 122;
   */
  IT_72_NAPLES = 122,

  /**
   * @generated from enum value: WORK_LOCATION_IT_34_VENICE = 123;
   */
  IT_34_VENICE = 123,

  /**
   * @generated from enum value: WORK_LOCATION_IT_52_FLORENCE = 124;
   */
  IT_52_FLORENCE = 124,

  /**
   * @generated from enum value: WORK_LOCATION_IT_45_BOLOGNA = 125;
   */
  IT_45_BOLOGNA = 125,

  /**
   * @generated from enum value: WORK_LOCATION_IT_82_PALERMO = 126;
   */
  IT_82_PALERMO = 126,

  /**
   * @generated from enum value: WORK_LOCATION_IT_42_GENOA = 127;
   */
  IT_42_GENOA = 127,

  /**
   * @generated from enum value: WORK_LOCATION_JP_13_TOKYO = 128;
   */
  JP_13_TOKYO = 128,

  /**
   * @generated from enum value: WORK_LOCATION_JP_27_OSAKA = 129;
   */
  JP_27_OSAKA = 129,

  /**
   * @generated from enum value: WORK_LOCATION_JP_26_KYOTO = 130;
   */
  JP_26_KYOTO = 130,

  /**
   * @generated from enum value: WORK_LOCATION_JP_14_YOKOHAMA = 131;
   */
  JP_14_YOKOHAMA = 131,

  /**
   * @generated from enum value: WORK_LOCATION_LV_RIX_RIGA = 132;
   */
  LV_RIX_RIGA = 132,

  /**
   * @generated from enum value: WORK_LOCATION_LT_VL_VILNIUS = 133;
   */
  LT_VL_VILNIUS = 133,

  /**
   * @generated from enum value: WORK_LOCATION_LT_KU_KAUNAS = 134;
   */
  LT_KU_KAUNAS = 134,

  /**
   * @generated from enum value: WORK_LOCATION_LU_L_LUXEMBOURG_CITY = 135;
   */
  LU_L_LUXEMBOURG_CITY = 135,

  /**
   * @generated from enum value: WORK_LOCATION_MY_14_KUALA_LUMPUR = 136;
   */
  MY_14_KUALA_LUMPUR = 136,

  /**
   * @generated from enum value: WORK_LOCATION_MY_01_ISKANDAR_JOHOR_BAHRU = 137;
   */
  MY_01_ISKANDAR_JOHOR_BAHRU = 137,

  /**
   * @generated from enum value: WORK_LOCATION_MX_CMX_MEXICO_CITY = 138;
   */
  MX_CMX_MEXICO_CITY = 138,

  /**
   * @generated from enum value: WORK_LOCATION_MX_JAL_GUADALAJARA = 139;
   */
  MX_JAL_GUADALAJARA = 139,

  /**
   * @generated from enum value: WORK_LOCATION_MX_JAL_PUERTO_VALLARTA = 140;
   */
  MX_JAL_PUERTO_VALLARTA = 140,

  /**
   * @generated from enum value: WORK_LOCATION_MX_BCN_TIJUANA = 141;
   */
  MX_BCN_TIJUANA = 141,

  /**
   * @generated from enum value: WORK_LOCATION_MX_BCN_ROSARITO = 142;
   */
  MX_BCN_ROSARITO = 142,

  /**
   * @generated from enum value: WORK_LOCATION_MX_BCN_ENSENADA = 143;
   */
  MX_BCN_ENSENADA = 143,

  /**
   * @generated from enum value: WORK_LOCATION_MX_BCS_LOS_CABOS = 144;
   */
  MX_BCS_LOS_CABOS = 144,

  /**
   * @generated from enum value: WORK_LOCATION_MX_NLE_MONTERREY = 145;
   */
  MX_NLE_MONTERREY = 145,

  /**
   * @generated from enum value: WORK_LOCATION_MX_OAX_OAXACA_CITY = 146;
   */
  MX_OAX_OAXACA_CITY = 146,

  /**
   * @generated from enum value: WORK_LOCATION_MX_PUE_PUEBLA_CITY = 147;
   */
  MX_PUE_PUEBLA_CITY = 147,

  /**
   * @generated from enum value: WORK_LOCATION_MX_VER_VERACRUZ_CITY = 148;
   */
  MX_VER_VERACRUZ_CITY = 148,

  /**
   * @generated from enum value: WORK_LOCATION_MX_CHP_SAN_CRISTOBAL = 149;
   */
  MX_CHP_SAN_CRISTOBAL = 149,

  /**
   * @generated from enum value: WORK_LOCATION_MX_ROO_CANCUN = 150;
   */
  MX_ROO_CANCUN = 150,

  /**
   * @generated from enum value: WORK_LOCATION_MX_YUC_MERIDA = 151;
   */
  MX_YUC_MERIDA = 151,

  /**
   * @generated from enum value: WORK_LOCATION_MX_CAM_CAMPECHE_CITY = 152;
   */
  MX_CAM_CAMPECHE_CITY = 152,

  /**
   * @generated from enum value: WORK_LOCATION_MX_GUA_LEON = 153;
   */
  MX_GUA_LEON = 153,

  /**
   * @generated from enum value: WORK_LOCATION_MX_SLP_SAN_LUIS_POTOSI_CITY = 154;
   */
  MX_SLP_SAN_LUIS_POTOSI_CITY = 154,

  /**
   * @generated from enum value: WORK_LOCATION_MX_MIC_MORELIA = 155;
   */
  MX_MIC_MORELIA = 155,

  /**
   * @generated from enum value: WORK_LOCATION_MX_GRO_ACAPULCO = 156;
   */
  MX_GRO_ACAPULCO = 156,

  /**
   * @generated from enum value: WORK_LOCATION_MX_CHH_CIUDAD_JUAREZ = 157;
   */
  MX_CHH_CIUDAD_JUAREZ = 157,

  /**
   * @generated from enum value: WORK_LOCATION_MX_DUR_DURANGO_CITY = 158;
   */
  MX_DUR_DURANGO_CITY = 158,

  /**
   * @generated from enum value: WORK_LOCATION_MX_ZAC_ZACATECAS_CITY = 159;
   */
  MX_ZAC_ZACATECAS_CITY = 159,

  /**
   * @generated from enum value: WORK_LOCATION_MA_06_CASABLANCA = 160;
   */
  MA_06_CASABLANCA = 160,

  /**
   * @generated from enum value: WORK_LOCATION_MA_07_MARRAKECH = 161;
   */
  MA_07_MARRAKECH = 161,

  /**
   * @generated from enum value: WORK_LOCATION_MA_09_OUARZAZATE = 162;
   */
  MA_09_OUARZAZATE = 162,

  /**
   * @generated from enum value: WORK_LOCATION_NZ_AUK_AUCKLAND = 163;
   */
  NZ_AUK_AUCKLAND = 163,

  /**
   * @generated from enum value: WORK_LOCATION_NZ_WGN_WELLINGTON = 164;
   */
  NZ_WGN_WELLINGTON = 164,

  /**
   * @generated from enum value: WORK_LOCATION_NZ_CAN_CHRISTCHURCH = 165;
   */
  NZ_CAN_CHRISTCHURCH = 165,

  /**
   * @generated from enum value: WORK_LOCATION_NZ_OTA_QUEENSTOWN = 166;
   */
  NZ_OTA_QUEENSTOWN = 166,

  /**
   * @generated from enum value: WORK_LOCATION_NO_03_OSLO = 167;
   */
  NO_03_OSLO = 167,

  /**
   * @generated from enum value: WORK_LOCATION_NO_46_BERGEN = 168;
   */
  NO_46_BERGEN = 168,

  /**
   * @generated from enum value: WORK_LOCATION_PH_00_MANILA_QUEZON_CITY = 169;
   */
  PH_00_MANILA_QUEZON_CITY = 169,

  /**
   * @generated from enum value: WORK_LOCATION_PH_CEB_CEBU_CITY = 170;
   */
  PH_CEB_CEBU_CITY = 170,

  /**
   * @generated from enum value: WORK_LOCATION_PL_14_WARSAW = 171;
   */
  PL_14_WARSAW = 171,

  /**
   * @generated from enum value: WORK_LOCATION_PL_12_KRAKOW = 172;
   */
  PL_12_KRAKOW = 172,

  /**
   * @generated from enum value: WORK_LOCATION_PL_10_LODZ = 173;
   */
  PL_10_LODZ = 173,

  /**
   * @generated from enum value: WORK_LOCATION_PL_02_WROCLAW = 174;
   */
  PL_02_WROCLAW = 174,

  /**
   * @generated from enum value: WORK_LOCATION_PL_30_POZNAN = 175;
   */
  PL_30_POZNAN = 175,

  /**
   * @generated from enum value: WORK_LOCATION_PL_24_KATOWICE = 176;
   */
  PL_24_KATOWICE = 176,

  /**
   * @generated from enum value: WORK_LOCATION_PT_11_LISBON = 177;
   */
  PT_11_LISBON = 177,

  /**
   * @generated from enum value: WORK_LOCATION_PT_13_PORTO = 178;
   */
  PT_13_PORTO = 178,

  /**
   * @generated from enum value: WORK_LOCATION_RO_B_BUCHAREST = 179;
   */
  RO_B_BUCHAREST = 179,

  /**
   * @generated from enum value: WORK_LOCATION_RO_CT_CONSTANTA = 180;
   */
  RO_CT_CONSTANTA = 180,

  /**
   * @generated from enum value: WORK_LOCATION_RU_MOW_MOSCOW = 181;
   */
  RU_MOW_MOSCOW = 181,

  /**
   * @generated from enum value: WORK_LOCATION_RU_SPE_ST_PETERSBURG = 182;
   */
  RU_SPE_ST_PETERSBURG = 182,

  /**
   * @generated from enum value: WORK_LOCATION_SA_01_RIYADH = 183;
   */
  SA_01_RIYADH = 183,

  /**
   * @generated from enum value: WORK_LOCATION_SA_02_JEDDAH = 184;
   */
  SA_02_JEDDAH = 184,

  /**
   * @generated from enum value: WORK_LOCATION_RS_00_BELGRADE = 185;
   */
  RS_00_BELGRADE = 185,

  /**
   * @generated from enum value: WORK_LOCATION_SG_01_SINGAPORE = 186;
   */
  SG_01_SINGAPORE = 186,

  /**
   * @generated from enum value: WORK_LOCATION_SK_BL_BRATISLAVA = 187;
   */
  SK_BL_BRATISLAVA = 187,

  /**
   * @generated from enum value: WORK_LOCATION_ZA_WC_CAPE_TOWN = 188;
   */
  ZA_WC_CAPE_TOWN = 188,

  /**
   * @generated from enum value: WORK_LOCATION_ZA_GP_JOHANNESBURG = 189;
   */
  ZA_GP_JOHANNESBURG = 189,

  /**
   * @generated from enum value: WORK_LOCATION_ZA_KZN_DURBAN = 190;
   */
  ZA_KZN_DURBAN = 190,

  /**
   * @generated from enum value: WORK_LOCATION_KR_11_SEOUL = 191;
   */
  KR_11_SEOUL = 191,

  /**
   * @generated from enum value: WORK_LOCATION_KR_26_BUSAN = 192;
   */
  KR_26_BUSAN = 192,

  /**
   * @generated from enum value: WORK_LOCATION_KR_41_GOYANG = 193;
   */
  KR_41_GOYANG = 193,

  /**
   * @generated from enum value: WORK_LOCATION_ES_MD_MADRID = 194;
   */
  ES_MD_MADRID = 194,

  /**
   * @generated from enum value: WORK_LOCATION_ES_CT_BARCELONA = 195;
   */
  ES_CT_BARCELONA = 195,

  /**
   * @generated from enum value: WORK_LOCATION_ES_VC_VALENCIA = 196;
   */
  ES_VC_VALENCIA = 196,

  /**
   * @generated from enum value: WORK_LOCATION_ES_AN_SEVILLE = 197;
   */
  ES_AN_SEVILLE = 197,

  /**
   * @generated from enum value: WORK_LOCATION_ES_AN_MALAGA = 198;
   */
  ES_AN_MALAGA = 198,

  /**
   * @generated from enum value: WORK_LOCATION_ES_PV_BILBAO = 199;
   */
  ES_PV_BILBAO = 199,

  /**
   * @generated from enum value: WORK_LOCATION_ES_CN_TENERIFE = 200;
   */
  ES_CN_TENERIFE = 200,

  /**
   * @generated from enum value: WORK_LOCATION_ES_CN_GRAN_CANARIA = 201;
   */
  ES_CN_GRAN_CANARIA = 201,

  /**
   * @generated from enum value: WORK_LOCATION_SE_AB_STOCKHOLM = 202;
   */
  SE_AB_STOCKHOLM = 202,

  /**
   * @generated from enum value: WORK_LOCATION_SE_O_GOTHENBURG = 203;
   */
  SE_O_GOTHENBURG = 203,

  /**
   * @generated from enum value: WORK_LOCATION_SE_M_MALMO = 204;
   */
  SE_M_MALMO = 204,

  /**
   * @generated from enum value: WORK_LOCATION_CH_ZH_ZURICH = 205;
   */
  CH_ZH_ZURICH = 205,

  /**
   * @generated from enum value: WORK_LOCATION_CH_GE_GENEVA = 206;
   */
  CH_GE_GENEVA = 206,

  /**
   * @generated from enum value: WORK_LOCATION_TH_10_BANGKOK = 207;
   */
  TH_10_BANGKOK = 207,

  /**
   * @generated from enum value: WORK_LOCATION_TH_50_CHIANG_MAI = 208;
   */
  TH_50_CHIANG_MAI = 208,

  /**
   * @generated from enum value: WORK_LOCATION_TH_83_PHUKET = 209;
   */
  TH_83_PHUKET = 209,

  /**
   * @generated from enum value: WORK_LOCATION_TR_34_ISTANBUL = 210;
   */
  TR_34_ISTANBUL = 210,

  /**
   * @generated from enum value: WORK_LOCATION_TR_06_ANKARA = 211;
   */
  TR_06_ANKARA = 211,

  /**
   * @generated from enum value: WORK_LOCATION_TR_07_ANTALYA = 212;
   */
  TR_07_ANTALYA = 212,

  /**
   * @generated from enum value: WORK_LOCATION_TR_35_IZMIR = 213;
   */
  TR_35_IZMIR = 213,

  /**
   * @generated from enum value: WORK_LOCATION_TR_61_TRABZON = 214;
   */
  TR_61_TRABZON = 214,

  /**
   * @generated from enum value: WORK_LOCATION_UA_32_KYIV = 215;
   */
  UA_32_KYIV = 215,

  /**
   * @generated from enum value: WORK_LOCATION_UA_51_ODESA = 216;
   */
  UA_51_ODESA = 216,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_LONDON = 217;
   */
  GB_ENG_LONDON = 217,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_MANCHESTER = 218;
   */
  GB_ENG_MANCHESTER = 218,

  /**
   * @generated from enum value: WORK_LOCATION_GB_SCT_GLASGOW = 219;
   */
  GB_SCT_GLASGOW = 219,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_BRISTOL = 220;
   */
  GB_ENG_BRISTOL = 220,

  /**
   * @generated from enum value: WORK_LOCATION_GB_WLS_CARDIFF = 221;
   */
  GB_WLS_CARDIFF = 221,

  /**
   * @generated from enum value: WORK_LOCATION_GB_SCT_EDINBURGH = 222;
   */
  GB_SCT_EDINBURGH = 222,

  /**
   * @generated from enum value: WORK_LOCATION_GB_NIR_BELFAST = 223;
   */
  GB_NIR_BELFAST = 223,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_BIRMINGHAM = 224;
   */
  GB_ENG_BIRMINGHAM = 224,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_LIVERPOOL = 225;
   */
  GB_ENG_LIVERPOOL = 225,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_LEEDS = 226;
   */
  GB_ENG_LEEDS = 226,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_BRIGHTON = 227;
   */
  GB_ENG_BRIGHTON = 227,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_NOTTINGHAM = 228;
   */
  GB_ENG_NOTTINGHAM = 228,

  /**
   * @generated from enum value: WORK_LOCATION_GB_ENG_NEWCASTLE = 229;
   */
  GB_ENG_NEWCASTLE = 229,

  /**
   * @generated from enum value: WORK_LOCATION_US_CA_LOS_ANGELES = 230;
   */
  US_CA_LOS_ANGELES = 230,

  /**
   * @generated from enum value: WORK_LOCATION_US_CA_SAN_FRANCISCO = 231;
   */
  US_CA_SAN_FRANCISCO = 231,

  /**
   * @generated from enum value: WORK_LOCATION_US_CA_SAN_DIEGO = 232;
   */
  US_CA_SAN_DIEGO = 232,

  /**
   * @generated from enum value: WORK_LOCATION_US_CA_SACRAMENTO = 233;
   */
  US_CA_SACRAMENTO = 233,

  /**
   * @generated from enum value: WORK_LOCATION_US_GA_ATLANTA = 234;
   */
  US_GA_ATLANTA = 234,

  /**
   * @generated from enum value: WORK_LOCATION_US_GA_SAVANNAH = 235;
   */
  US_GA_SAVANNAH = 235,

  /**
   * @generated from enum value: WORK_LOCATION_US_NY_NEW_YORK_CITY = 236;
   */
  US_NY_NEW_YORK_CITY = 236,

  /**
   * @generated from enum value: WORK_LOCATION_US_NY_BUFFALO = 237;
   */
  US_NY_BUFFALO = 237,

  /**
   * @generated from enum value: WORK_LOCATION_US_NY_HUDSON_VALLEY = 238;
   */
  US_NY_HUDSON_VALLEY = 238,

  /**
   * @generated from enum value: WORK_LOCATION_US_NM_ALBUQUERQUE = 239;
   */
  US_NM_ALBUQUERQUE = 239,

  /**
   * @generated from enum value: WORK_LOCATION_US_NM_SANTA_FE = 240;
   */
  US_NM_SANTA_FE = 240,

  /**
   * @generated from enum value: WORK_LOCATION_US_LA_NEW_ORLEANS = 241;
   */
  US_LA_NEW_ORLEANS = 241,

  /**
   * @generated from enum value: WORK_LOCATION_US_LA_BATON_ROUGE = 242;
   */
  US_LA_BATON_ROUGE = 242,

  /**
   * @generated from enum value: WORK_LOCATION_US_TX_AUSTIN = 243;
   */
  US_TX_AUSTIN = 243,

  /**
   * @generated from enum value: WORK_LOCATION_US_TX_DALLAS_FORT_WORTH = 244;
   */
  US_TX_DALLAS_FORT_WORTH = 244,

  /**
   * @generated from enum value: WORK_LOCATION_US_TX_HOUSTON = 245;
   */
  US_TX_HOUSTON = 245,

  /**
   * @generated from enum value: WORK_LOCATION_US_IL_CHICAGO = 246;
   */
  US_IL_CHICAGO = 246,

  /**
   * @generated from enum value: WORK_LOCATION_US_MA_BOSTON = 247;
   */
  US_MA_BOSTON = 247,

  /**
   * @generated from enum value: WORK_LOCATION_US_NC_WILMINGTON = 248;
   */
  US_NC_WILMINGTON = 248,

  /**
   * @generated from enum value: WORK_LOCATION_US_NC_CHARLOTTE = 249;
   */
  US_NC_CHARLOTTE = 249,

  /**
   * @generated from enum value: WORK_LOCATION_US_FL_MIAMI = 250;
   */
  US_FL_MIAMI = 250,

  /**
   * @generated from enum value: WORK_LOCATION_US_FL_ORLANDO = 251;
   */
  US_FL_ORLANDO = 251,

  /**
   * @generated from enum value: WORK_LOCATION_US_FL_TAMPA_BAY = 252;
   */
  US_FL_TAMPA_BAY = 252,

  /**
   * @generated from enum value: WORK_LOCATION_US_MI_DETROIT = 253;
   */
  US_MI_DETROIT = 253,

  /**
   * @generated from enum value: WORK_LOCATION_US_PA_PHILADELPHIA = 254;
   */
  US_PA_PHILADELPHIA = 254,

  /**
   * @generated from enum value: WORK_LOCATION_US_PA_PITTSBURGH = 255;
   */
  US_PA_PITTSBURGH = 255,

  /**
   * @generated from enum value: WORK_LOCATION_US_TN_NASHVILLE = 256;
   */
  US_TN_NASHVILLE = 256,

  /**
   * @generated from enum value: WORK_LOCATION_US_TN_MEMPHIS = 257;
   */
  US_TN_MEMPHIS = 257,

  /**
   * @generated from enum value: WORK_LOCATION_US_HI_HONOLULU = 258;
   */
  US_HI_HONOLULU = 258,

  /**
   * @generated from enum value: WORK_LOCATION_US_NV_LAS_VEGAS = 259;
   */
  US_NV_LAS_VEGAS = 259,

  /**
   * @generated from enum value: WORK_LOCATION_US_WA_SEATTLE = 260;
   */
  US_WA_SEATTLE = 260,

  /**
   * @generated from enum value: WORK_LOCATION_US_OR_PORTLAND = 261;
   */
  US_OR_PORTLAND = 261,

  /**
   * @generated from enum value: WORK_LOCATION_US_AZ_PHOENIX = 262;
   */
  US_AZ_PHOENIX = 262,

  /**
   * @generated from enum value: WORK_LOCATION_US_CO_DENVER = 263;
   */
  US_CO_DENVER = 263,

  /**
   * @generated from enum value: WORK_LOCATION_US_UT_SALT_LAKE_CITY = 264;
   */
  US_UT_SALT_LAKE_CITY = 264,

  /**
   * @generated from enum value: WORK_LOCATION_US_OH_CLEVELAND = 265;
   */
  US_OH_CLEVELAND = 265,

  /**
   * @generated from enum value: WORK_LOCATION_US_OH_CINCINNATI = 266;
   */
  US_OH_CINCINNATI = 266,

  /**
   * @generated from enum value: WORK_LOCATION_US_SC_CHARLESTON = 267;
   */
  US_SC_CHARLESTON = 267,

  /**
   * @generated from enum value: WORK_LOCATION_US_VA_RICHMOND = 268;
   */
  US_VA_RICHMOND = 268,

  /**
   * @generated from enum value: WORK_LOCATION_US_VA_NORFOLK = 269;
   */
  US_VA_NORFOLK = 269,

  /**
   * @generated from enum value: WORK_LOCATION_US_MD_BALTIMORE = 270;
   */
  US_MD_BALTIMORE = 270,

  /**
   * @generated from enum value: WORK_LOCATION_US_CT_HARTFORD = 271;
   */
  US_CT_HARTFORD = 271,

  /**
   * @generated from enum value: WORK_LOCATION_US_CT_NEW_HAVEN = 272;
   */
  US_CT_NEW_HAVEN = 272,

  /**
   * @generated from enum value: WORK_LOCATION_US_MO_KANSAS_CITY = 273;
   */
  US_MO_KANSAS_CITY = 273,

  /**
   * @generated from enum value: WORK_LOCATION_US_MO_ST_LOUIS = 274;
   */
  US_MO_ST_LOUIS = 274,

  /**
   * @generated from enum value: WORK_LOCATION_US_MN_MINNEAPOLIS = 275;
   */
  US_MN_MINNEAPOLIS = 275,

  /**
   * @generated from enum value: WORK_LOCATION_US_OK_OKLAHOMA_CITY = 276;
   */
  US_OK_OKLAHOMA_CITY = 276,

  /**
   * @generated from enum value: WORK_LOCATION_US_OK_TULSA = 277;
   */
  US_OK_TULSA = 277,

  /**
   * @generated from enum value: WORK_LOCATION_US_KY_LOUISVILLE = 278;
   */
  US_KY_LOUISVILLE = 278,

  /**
   * @generated from enum value: WORK_LOCATION_US_NJ_NEWARK = 279;
   */
  US_NJ_NEWARK = 279,

  /**
   * @generated from enum value: WORK_LOCATION_US_NJ_JERSEY_CITY = 280;
   */
  US_NJ_JERSEY_CITY = 280,

  /**
   * @generated from enum value: WORK_LOCATION_US_IN_INDIANAPOLIS = 281;
   */
  US_IN_INDIANAPOLIS = 281,

  /**
   * @generated from enum value: WORK_LOCATION_US_WI_MILWAUKEE = 282;
   */
  US_WI_MILWAUKEE = 282,

  /**
   * @generated from enum value: WORK_LOCATION_US_AL_BIRMINGHAM = 283;
   */
  US_AL_BIRMINGHAM = 283,

  /**
   * @generated from enum value: WORK_LOCATION_US_AL_MONTGOMERY = 284;
   */
  US_AL_MONTGOMERY = 284,

  /**
   * @generated from enum value: WORK_LOCATION_US_WV_CHARLESTON = 285;
   */
  US_WV_CHARLESTON = 285,

  /**
   * @generated from enum value: WORK_LOCATION_US_AR_LITTLE_ROCK = 286;
   */
  US_AR_LITTLE_ROCK = 286,

  /**
   * @generated from enum value: WORK_LOCATION_US_MT_BOZEMAN = 287;
   */
  US_MT_BOZEMAN = 287,

  /**
   * @generated from enum value: WORK_LOCATION_US_MT_MISSOULA = 288;
   */
  US_MT_MISSOULA = 288,

  /**
   * @generated from enum value: WORK_LOCATION_US_WY_JACKSON_HOLE = 289;
   */
  US_WY_JACKSON_HOLE = 289,

  /**
   * @generated from enum value: WORK_LOCATION_US_AK_ANCHORAGE = 290;
   */
  US_AK_ANCHORAGE = 290,

  /**
   * @generated from enum value: WORK_LOCATION_US_DE_WILMINGTON = 291;
   */
  US_DE_WILMINGTON = 291,

  /**
   * @generated from enum value: WORK_LOCATION_US_ID_BOISE = 292;
   */
  US_ID_BOISE = 292,

  /**
   * @generated from enum value: WORK_LOCATION_US_IA_DES_MOINES = 293;
   */
  US_IA_DES_MOINES = 293,

  /**
   * @generated from enum value: WORK_LOCATION_US_KS_WICHITA = 294;
   */
  US_KS_WICHITA = 294,

  /**
   * @generated from enum value: WORK_LOCATION_US_ME_PORTLAND = 295;
   */
  US_ME_PORTLAND = 295,

  /**
   * @generated from enum value: WORK_LOCATION_US_MS_JACKSON = 296;
   */
  US_MS_JACKSON = 296,

  /**
   * @generated from enum value: WORK_LOCATION_US_NE_OMAHA = 297;
   */
  US_NE_OMAHA = 297,

  /**
   * @generated from enum value: WORK_LOCATION_US_NH_MANCHESTER = 298;
   */
  US_NH_MANCHESTER = 298,

  /**
   * @generated from enum value: WORK_LOCATION_US_ND_FARGO = 299;
   */
  US_ND_FARGO = 299,

  /**
   * @generated from enum value: WORK_LOCATION_US_RI_PROVIDENCE = 300;
   */
  US_RI_PROVIDENCE = 300,

  /**
   * @generated from enum value: WORK_LOCATION_US_SD_SIOUX_FALLS = 301;
   */
  US_SD_SIOUX_FALLS = 301,

  /**
   * @generated from enum value: WORK_LOCATION_US_VT_BURLINGTON = 302;
   */
  US_VT_BURLINGTON = 302,
}

/**
 * Describes the enum protos.general.WorkLocation.
 */
export const WorkLocationSchema: GenEnum<WorkLocation> = /*@__PURE__*/
  enumDesc(file_general_work_location, 0);

